<!-- Nav Menu -->

<template>
  <div id="app">
    <template v-if="$route.name == 'home' || $route.name == 'adt'">
      <template v-if="develop == 'adt'">
        <MenuADT
          @season="setSeason"
          @seasonsadt="Setseasonsadt"
          @custom-event-name="setMessage"
          @currentReport="setReport"
          @currentTitle="setTitle"
          @devCode="setdevCode"
          :config="env"
          :develop="develop"
        />
      </template>
      <template v-else>
        <Menu
          @season="setSeason"
          @seasonsadt="Setseasonsadt"
          @custom-event-name="setMessage"
          @currentReport="setReport"
          @currentTitle="setTitle"
          :config="env"
          :develop="develop"
        />
      </template>
      <transition name="fade" appear>
        <router-view
          :key="$route.fullPath"
          :develop="develop"
          :currentReport="currentReport"
          :devCode="devCode"
          :title="currentTitle"
          :season="season"
          :seasonsadt="seasonsadt"
          :oom="oom"
          :config="env"
      /></transition>
      <CookieBanner />
    </template>
    <template v-else>
      <template v-if="develop == 'adt'">
        <MenuADT
          @season="setSeason"
          @seasonsadt="Setseasonsadt"
          @custom-event-name="setMessage"
          @currentReport="setReport"
          @currentTitle="setTitle"
          @devCode="setdevCode"
          :config="env"
          :develop="develop"
        />
      </template>
      <template v-else>
        <Menu
          @season="setSeason"
          @seasonsadt="Setseasonsadt"
          @custom-event-name="setMessage"
          @currentReport="setReport"
          @currentTitle="setTitle"
          :config="env"
          :develop="develop"
        />
      </template>
      <transition name="fade" appear>
        <router-view
          :key="$route.fullPath"
          :develop="develop"
          :currentReport="currentReport"
          :devCode="devCode"
          :season="season"
          :seasonsadt="seasonsadt"
          :oom="oom"
          :config="env"
      /></transition>
      <CookieBanner />
    </template>
    <Footer
     :develop="develop" 
     :config="env"
    @currentTitle="setTitle"
     :currentReport="currentReport"
     :season="season"
     />
  </div>
</template>
<script>
  <meta name="apple-itunes-app" content="app-id=1380083557"></meta>
</script>
<style>
a {
  color: #337ab7;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14pt;
}
li.nav-item::marker {
  color: transparent;
}
h3 {
  font-size: 24px !important;
  font-weight: 700;
}

@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>

<script>
import Footer from "@/components/footer.vue";
import Menu from "@/components/menu.vue";
import MenuADT from "@/components/menuadt.vue";
import CookieBanner from "@/components/CookieBanner.vue";
export default {
  components: {
    Footer,
    Menu,
    MenuADT,
    CookieBanner
  },
  data() {
    return {
      develop: "",
      season: "",
      seasonsadt:'',
      devCode:'',
      oom: "",
      env: [],
      currentReport: "",
      currentTitle: "",
    };
  },
  methods: {
    // Define method that will use the payload to update the data property
    setReport(payload) {
      this.currentReport = payload.currentReport;
    },
    setdevCode(payload) {
      this.devCode = payload.devCode;
    },
    setTitle(payload) {
      this.currentTitle = payload.currentTitle;
    },
    setMessage(payload) {
      this.develop = payload.develop;
      this.oom = payload.oom;
    },
    setSeason(payload) {
      this.season = payload.season;
    },
    Setseasonsadt(payload) {
      this.seasonsadt = payload.seasonsadt;
    },
    setDevelop() {
      if (this.$route.name === "adt" || this.$route.name === 'adt-newStory' || this.develop === "adt" || this.$route.fullPath.includes('adt')) {
        (this.develop = process.env.VUE_APP_ID_ADT),
          (this.oom = process.env.VUE_APP_ADT_OOM);
      } else {
        (this.develop = process.env.VUE_APP_ID_ASIAN_TOUR),
        (this.oom = process.env.VUE_APP_ASIAN_OOM);
      }
    },
  },
  watch: {
    $route() {
      this.$nextTick(this.setDevelop);
    },
  },
  mounted() {
    this.env = process.env;
    this.$route.onReady(() => this.setDevelop());
    // window.onorientationchange = function() { window.location.reload() };
  },
};
</script>